import { LocalizationHelperService } from '../shared/localization/localization-helper.service';
import { configurableFormValidationMessagesBuilder } from './validations.formly';

export function formlyConfigBuilder(localization: LocalizationHelperService) {
  return {
    validationMessages: configurableFormValidationMessagesBuilder(localization),
  };
}
